import React, { useState, useEffect } from "react";
import StepperPage from "./StepperPage";
import { Trans } from "react-i18next";
import DisplayTemplate from "./DisplayTemplate";
import { documentLimitReached } from "../../utils/LicenceUtils";
import TemplateList from "./TemplateList";
import Alert from "@material-ui/lab/Alert";
import {
  DialogActions,
  Button,
  Typography,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Add, Close, Description } from "@material-ui/icons";
import CreateTemplate from "../template/CreateTemplate";
import CloseIcon from "@material-ui/icons/Close";
import { connect } from "react-redux";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "row",
    flex: 1,
    minHeight: 0,
  },
  list: {
    flex: 0.2,
    display: "flex",
    flexDirection: "column",
    borderRight: "1px solid rgba(0, 0, 0, 0.12)",
    height: "100%",
    direction: "rtl",
    overflow: "auto",
  },

  orSeparator: {
    borderBottom: "1px solid #eee",
    padding: "10px 0",
    position: "relative",
    display: "block",
    marginBottom: 25,
    fontSize: "1em",
  },
  orText: {
    position: "absolute",
    left: "49%",
    top: 0,
    background: "#fff",
    padding: 10,
    color: "rgba(0,0,0,.45)",
  },
}));
function TemplatePicker(props) {
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [isCreate, setIsCreate] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [limitReached, setLimitReached] = useState(documentLimitReached())
  const classes = useStyles();

  useEffect(() => {
    props.setNextDisabled(true);
    if (limitReached) {
      props.setDisabledHelperText(
        <Trans i18nKey="create_content_document_limit_reached_button_disabled">
          create_content_document_limit_reached_button_disabled
        </Trans>
      );
    } else {
      props.setDisabledHelperText(
        <Trans i18nKey="create_content_select_template_button_disabled">
          create_content_select_template_button_disabled
        </Trans>
      );
    }
  }, []);

  useEffect(
    () => {
      if (selectedTemplate) {
        if (!limitReached) {
          props.setNextDisabled(false);
        }
        props.onTemplateSelected(selectedTemplate);
      }
    },
    [selectedTemplate]
  );
  const openNewTemplate = () => {
    setIsCreate(true);
    setIsEdit(false);
  };
  const templateSelect = () => {};
  const editTemplate = () => {
    setIsCreate(false);
    setIsEdit(true);
  };
  const closeCreateTemplate = () => {
    setIsCreate(false);
    setIsEdit(false);
    let tempSelectedTemplate = selectedTemplate;
    setSelectedTemplate(null);

    // setSelectedTemplate(tempSelectedTemplate);
  };

  const onClearCurrent = (template) => {
    if (selectedTemplate) {
      template === selectedTemplate.id && setSelectedTemplate(null);
    }
  };
  const onSave = (template) => {};
  return (
    <div
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        overflow: "auto",
      }}
      id="dfgds"
    >
      {!props.hideTitle && (
        <div
          style={{ marginBottom: 10, display: "flex", flexDirection: "row" }}
        >
          <div style={{ width: "100%" }}>
            <Typography variant="h5">
              <Trans i18nKey="create_content_select_template_header">
                create_content_select_template_headern
              </Trans>
            </Typography>
            <Typography variant="body2" gutterBottom>
              <Trans i18nKey="create_content_select_template_subheader">
                create_content_select_template_subheader
              </Trans>
            </Typography>
          </div>
          {props.onClose && (
            <IconButton onClick={props.onClose}>
              <CloseIcon />
            </IconButton>
          )}
        </div>
      )}
      {!props.noFromFile && (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {limitReached && (
              <Alert
                severity="error"
                style={{ width: "50%", marginBottom: 15 }}
              >
                <Trans i18nKey="create_content_document_limit_reached">
                  create_content_document_limit_reached
                </Trans>
              </Alert>
            )}
            <Typography variant="body2" gutterBottom>
              <Trans i18nKey="create_content_create_from_file">
                create_content_create_from_file
              </Trans>
            </Typography>
            <Button
              onClick={props.nextFileUpload}
              variant="outlined"
              disabled={limitReached}
              startIcon={<Description />}
            >
              create from file
            </Button>
          </div>
          <div className={classes.orSeparator}>
            <span className={classes.orText}>OR</span>
          </div>
        </>
      )}
      <div className={classes.container}>
        <div className={classes.list}>
          <Typography
            style={{ margin: "8px", fontWeight: "bold", direction: "ltr" }}
            variant="subtitle1"
          >
            <Trans i18nKey="create_content_pick_template">
              create_content_pick_template
            </Trans>
          </Typography>
          {props.user.userPermits.roles.contentAdmin && (
            <DialogActions style={{ justifyContent: "center" }}>
              <Button
                onClick={openNewTemplate}
                variant="outlined"
                startIcon={<Add />}
                style={{ direction: "ltr" }}
              >
                <Trans i18nKey="create_content_new_template_button">
                  create_content_new_template_button
                </Trans>
              </Button>
            </DialogActions>
          )}
          <TemplateList
            displayTemplate={(e) => setSelectedTemplate(e)}
            clearCurrent={onClearCurrent}
          />
        </div>
        <div style={{ flex: 0.8, display: "flex", overflow: "auto" }}>
          {selectedTemplate ? (
            <DisplayTemplate
              customFields={selectedTemplate.customFields}
              templateSelect={templateSelect}
              editTemplate={editTemplate}
              template={selectedTemplate}
              templatePicker
            />
          ) : (
            <div style={{ margin: "auto" }}>
              <Typography>
                <Trans i18nKey="create_content_select_template">
                  create_content_select_template
                </Trans>
              </Typography>
            </div>
          )}
        </div>
      </div>
      {(isCreate || isEdit) && (
        <Dialog
          fullScreen
          open={isCreate || isEdit}
          style={{ display: "flex", flexDirection: "column" }}
          onClose={closeCreateTemplate}
        >
          <AppBar style={{ position: "relative" }}>
            <Toolbar>
              <IconButton
                color="inherit"
                onClick={closeCreateTemplate}
                aria-label="Close"
              >
                <Close />
              </IconButton>
              <Typography variant="h6" color="inherit">
                {isEdit ? (
                  <Trans i18nKey="create_template_header_edit" />
                ) : (
                  <Trans i18nKey="create_template_header">
                    create_template_header
                  </Trans>
                )}
              </Typography>
            </Toolbar>
          </AppBar>
          <CreateTemplate
            goHome={closeCreateTemplate}
            onTemplateSave={onSave}
            template={isEdit ? selectedTemplate : null}
            editTemplate={isEdit}
          />
        </Dialog>
      )}
    </div>
  );
}
const mapStateToProps = (state) => ({
  user: state.user.currentUser,
});
export default connect(
  mapStateToProps,
  null
)(StepperPage(TemplatePicker));
